(function () {
  if (window.__hbProductCardInit) return;
  window.__hbProductCardInit = true;

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-hb-add-to-cart]');
    if (!button || button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var labels = button.querySelectorAll('.hb-card__cta-label');
    var originalTexts = [];
    labels.forEach(function (el) { originalTexts.push(el.textContent); });

    function setLabels(text) {
      labels.forEach(function (el) { el.textContent = text; });
    }

    function restoreLabels() {
      labels.forEach(function (el, i) { el.textContent = originalTexts[i]; });
    }

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (data) { throw new Error(data.description || 'Add to cart failed'); });
        return res.json();
      })
      .then(function () {
        button.classList.remove('is-loading');
        button.classList.add('is-added');
        setLabels(((window.hbStrings || {}).added || 'Lisätty!'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:refresh'));

        setTimeout(function () {
          button.classList.remove('is-added');
          button.disabled = false;
          restoreLabels();
        }, 2000);
      })
      .catch(function (err) {
        button.classList.remove('is-loading');
        button.disabled = false;
        setLabels(((window.hbStrings || {}).error || 'Virhe — yritä uudelleen'));
        setTimeout(function () {
          restoreLabels();
        }, 2500);
        console.error('HejBuddy add-to-cart error:', err);
      });
  });
})();